import { Component, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { TripStoreService } from 'src/app/itineries/services/store/trip-store/trip-store.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-vertical-stacked-bar-chart',
  templateUrl: './vertical-stacked-bar-chart.component.html',
  styleUrls: ['./vertical-stacked-bar-chart.component.css']
})
export class VerticalStackedBarChartComponent implements OnInit {
  // Stacked bar chart configuration
  barChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        stacked: true
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true
        }
      }]
    },
    tooltips: {
      mode: 'index',
      intersect: false
    }
  };

  barChartLabels = [];

  barChartType = 'bar' as const;

  barChartLegend = false;

  barChartData = [];

  timeZone: any;
  user: any;

  constructor(
    private sharedDataService: SharedDataService,
    private tripStoreService: TripStoreService,
  ) { }

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;
          this.prepareData();
        }
      });
  }

  prepareData() {
    this.tripStoreService.state$.subscribe((res) => {
      if (res) {
        this.calculateStats(res.list);
      }
    }
    );
  }

  calculateStats(trips) {
    this.barChartLabels = [];
    this.barChartData = [
      {
        data: [],
        label: 'On Time',
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1
      },
      {
        data: [],
        label: '0-15 Late',
        backgroundColor: 'rgba(54, 162, 235, 0.7)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1
      },
      {
        data: [],
        label: '15-30 Late',
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1
      },
      {
        data: [],
        label: '30-60 Late',
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1
      },
      {
        data: [],
        label: '60+ Late',
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1
      }
    ];

    const groupedTrips: { [hour: string]: any[] } = {};
    trips.forEach(trip => {

      if (!trip.job || !trip.job.trackInfoJob || !["cancelled", "finished"].includes(trip.status)) return;
      // Round to start of the hour
      const pickupHourSlot = moment(trip.appointmentTime)
        .tz(this.timeZone)
        .startOf('hour')
        .format('HH:mm:ss');

      if (!groupedTrips[pickupHourSlot]) {
        groupedTrips[pickupHourSlot] = [];
      }

      groupedTrips[pickupHourSlot].push(trip);
    });

    this.barChartLabels = Object.keys(groupedTrips).sort((a, b) => {
      return moment(a, 'HH:mm:ss').diff(moment(b, 'HH:mm:ss'));
    });

    const lateStatusIndex = {
      onTime: 0,
      zeroToFifteenLate: 1,
      fifteenToThirtyLate: 2,
      thirtyToSixtyLate: 3,
      sixtyPlusLate: 4
    };

    for (const key in groupedTrips) {
      const lateNumbers = {
        onTime: 0,
        zeroToFifteenLate: 0,
        fifteenToThirtyLate: 0,
        thirtyToSixtyLate: 0,
        sixtyPlusLate: 0
      };

      for (const trip of groupedTrips[key]) {

        if (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time) {
          // check schedule time.
          const timeOne = moment(trip.job.trackInfoJob.jobFinished.time).tz(this.timeZone);
          const timeTwo = moment(trip.appointmentTime).tz(this.timeZone);

          if (timeOne.isAfter(timeTwo)) {
            const difference = timeOne.diff(timeTwo, 'minutes');

            if (difference <= 15) {
              lateNumbers.zeroToFifteenLate += 1;
            } else if (difference > 15 && difference <= 30) {
              lateNumbers.fifteenToThirtyLate += 1;
            } else if (difference > 30 && difference <= 60) {
              lateNumbers.thirtyToSixtyLate += 1;
            } else {
              lateNumbers.sixtyPlusLate += 1;
            }

          } else {
            lateNumbers.onTime += 1;
          }
        }
      }

      this.barChartData[lateStatusIndex.onTime].data.push(lateNumbers.onTime);
      this.barChartData[lateStatusIndex.zeroToFifteenLate].data.push(lateNumbers.zeroToFifteenLate);
      this.barChartData[lateStatusIndex.fifteenToThirtyLate].data.push(lateNumbers.fifteenToThirtyLate);
      this.barChartData[lateStatusIndex.thirtyToSixtyLate].data.push(lateNumbers.thirtyToSixtyLate);
      this.barChartData[lateStatusIndex.sixtyPlusLate].data.push(lateNumbers.sixtyPlusLate);
    }
  }

  ngOnDestroy(): void {

  }

}

